import React from 'react';
import { ThemeProvider } from 'styled-components';
import {
  RebrandingProvider,
  createTheme,
} from '@xingternal/rebranding-adapter';
import { FEATURE_SWITCHES } from '@config/app.constants';

const wineryTheme = createTheme();

const BrandProvider = ({ children }) => {
  const isFeatureFlagsAvailable = window?.featureSwitches?.length > 0;
  const isXingRebrandingEnabled = window?.featureSwitches?.includes(
    FEATURE_SWITCHES.XING_REBRANDING_ENABLED,
  );

  // when flag feature is available, we assumed user is logged in and rebranding was evaluated above in the tree
  // so we avoid to redo it to not overwrite RebrandingProvider with environment variables
  if (isFeatureFlagsAvailable) {
    return children;
  }

  const rebranding = {
    enableXingRebranding: isXingRebrandingEnabled,
  };

  return (
    <RebrandingProvider featureFlags={rebranding}>
      <ThemeProvider theme={wineryTheme(rebranding)}>{children}</ThemeProvider>
    </RebrandingProvider>
  );
};

export { BrandProvider };
